import { render, staticRenderFns } from "./ClassTrialSkillsTable.vue?vue&type=template&id=63ad8a8c"
import script from "./ClassTrialSkillsTable.vue?vue&type=script&lang=js"
export * from "./ClassTrialSkillsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports